// extracted by mini-css-extract-plugin
module.exports = {"root":"CommonBanner_root__2tZS_","content":"CommonBanner_content__XsDe5","left":"CommonBanner_left__Iv0Le","right":"CommonBanner_right__2MVp0"};